import { useQuery } from "react-query";
import axiosInstance from "./axiosInstance";
import { MediaDocLinksRes } from "../../types/ResType";
import { useAppSelector } from "../../utils/hooks";

export const useConversationDocuments = () => {
  const currentConversationData = useAppSelector(
    (state) => state.CurrentConversation,
  );

  return useQuery<MediaDocLinksRes, Error>(
    ["doc", currentConversationData.chat_id],
    async () => {
      const response = await axiosInstance.post<MediaDocLinksRes>("chat/chat-media", {
        chat_id: currentConversationData.chat_id,
        message_type: "doc",
        pageSize: 1000,
      });
      return response.data;
    },
    {
      staleTime: Infinity,
      cacheTime: Infinity,
    },
  );
};
